<template>
  <v-container fluid>
    <v-card
      v-if="countStatus && countStatus['pending'] && selectedBot.pageid == '100207768987988'"
      elevation="3"
      class="my-4 px-2 py-3"
    >
      <h1 class="mt-0 mb-3 font-total-case">Total Case : {{ numberWithCommas(sumCountStatus) }}</h1>
      <v-divider class="my-4"></v-divider>
      <v-layout row wrap justify-center>
        <v-flex
          v-if="countStatus && countStatus['pending']"
          xs12
          sm5
          md3
          class="py-2 px-2 box-status bg-pending mr-2 mt-2"
        >
          <div class="text-center font-bold">{{ numberWithCommas(countStatus['pending']) }}</div>
          <div class="text-center font-light">Pending</div>
        </v-flex>
        <v-flex
          v-if="countStatus && countStatus['answered']"
          xs12
          sm5
          md3
          class="py-2 px-2 box-status bg-pending mr-2 mt-2"
        >
          <div class="text-center font-bold">{{ numberWithCommas(countStatus['answered']) }}</div>
          <div class="text-center font-light">Answered</div>
        </v-flex>
        <v-flex
          v-if="countStatus && countStatus['closed']"
          xs12
          sm5
          md3
          class="py-2 px-2 box-status bg-pending mr-2 mt-2"
        >
          <div class="text-center font-bold">{{ numberWithCommas(countStatus['closed']) }}</div>
          <div class="text-center font-light">Closed</div>
        </v-flex>
        <v-flex
          v-if="countStatus && countStatus['cancelled']"
          xs12
          sm5
          md3
          class="py-2 px-2 box-status bg-cancledbycustomer mr-2 mt-2"
        >
          <div class="text-center font-bold">{{ numberWithCommas(countStatus['cancelled']) }}</div>
          <div class="text-center font-light">Cancelled</div>
        </v-flex>
        <v-flex
          v-if="countStatus && countStatus['cancelledbycustomer']"
          xs12
          sm5
          md3
          class="py-2 px-2 box-status bg-cancledbycustomer mr-2 mt-2"
        >
          <div class="text-center font-bold">
            {{ numberWithCommas(countStatus['cancelledbycustomer']) }}
          </div>
          <div class="text-center">Cancelled by customer</div>
        </v-flex>
      </v-layout>
    </v-card>
    <v-layout>
      <v-flex xs6> <h1 class="headline mt-2">Ticket List</h1> </v-flex>
      <v-flex xs6 class="text-xs-right">
        <span>
          <v-btn
            :loading="exportloading"
            outline
            color="grey"
            class="ma-0 mb-0"
            @click="showExportTicket = true"
          >
            <em class="fas fa-file-export mr-1" /> {{ $t('export') }}
          </v-btn>
        </span>
        <template v-if="$store.state.privilege && $store.state.privilege.create_ticket">
          <edit-ticket-monix
            v-if="isMonix"
            :type="'add'"
            :loading="loading"
            @addTicket="onAddTicket"
          ></edit-ticket-monix>
          <edit-ticket
            v-else
            :type="'add'"
            :loading="loading"
            @addTicket="onAddTicket"
          ></edit-ticket>
        </template>

        <v-btn color="primary" depressed :loading="loading" @click="showSearch = true">
          <v-icon class="mr-1">search</v-icon>Search
        </v-btn>
        <v-btn :loading="loading" color="primary" icon @click="onSearch">
          <em class="fas fa-sync-alt" />
        </v-btn>
        <v-dialog v-model="showSearch" persistent max-width="600" scrollable>
          <v-card>
            <div class="text-xs-right">
              <v-btn small flat fab :loading="loading" @click="showSearch = false">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
            <v-divider></v-divider>
            <v-card-text max-height="600">
              <div xs12 sm12>
                <div class="caption">ID</div>
                <div class="form-control"><input v-model="filter.id" type="number" /></div>
              </div>
              <div class="caption">Channel</div>
              <v-radio-group v-model="filter.channel" d-inline row>
                <v-radio class="mb-2" :value="null" color="primary" label="All"></v-radio>
                <v-radio
                  class="mb-2"
                  :value="'facebook'"
                  color="primary"
                  label="Facebook"
                ></v-radio>
                <v-radio class="mb-2" :value="'line'" color="primary" label="Line"></v-radio>
                <v-radio
                  v-if="isNT"
                  class="mb-2"
                  :value="'webchat'"
                  color="primary"
                  label="Webchat"
                ></v-radio>
                <v-radio class="mb-2" :value="'phone'" color="primary" label="Phone"></v-radio>
                <v-radio class="mb-2" :value="'email'" color="primary" label="Email"></v-radio>
                <v-radio class="mb-2" :value="'website'" color="primary" label="Website"></v-radio>
                <v-radio class="mb-2" :value="'others'" color="primary" label="Others"></v-radio>
              </v-radio-group>

              <div class="caption">Status</div>
              <v-radio-group v-model="filter.status" d-inline row>
                <v-radio class="mb-2" :value="null" color="primary" label="All"></v-radio>
                <v-radio class="mb-2" :value="'pending'" color="primary" label="Pending"></v-radio>
                <v-radio
                  class="mb-2"
                  :value="'answered'"
                  color="primary"
                  label="Answered"
                ></v-radio>
                <v-radio class="mb-2" :value="'closed'" color="primary" label="Closed"></v-radio>
                <v-radio
                  class="mb-2"
                  :value="'cancelled'"
                  color="primary"
                  label="Cancelled"
                ></v-radio>
                <v-radio
                  class="mb-2"
                  :value="'cancelled by customer'"
                  color="primary"
                  label="Cancelled by customer"
                ></v-radio>
                <v-radio
                  v-if="selectedBot.type == 'truecorp'"
                  class="mb-2"
                  :value="'success'"
                  color="primary"
                  label="success"
                ></v-radio>
                <v-radio
                  v-if="selectedBot.theme == 'seagull'"
                  class="mb-2"
                  :value="'in progress'"
                  color="primary"
                  label="in progress"
                ></v-radio>
              </v-radio-group>

              <div v-if="selectedBot.pageid == '101760532365601'">
                <div class="caption">บอทตอบ</div>
                <v-radio-group v-model="filter.botreply" d-inline row>
                  <v-radio class="mb-2" :value="null" color="primary" label="All"></v-radio>
                  <v-radio class="mb-2" :value="true" color="primary" label="ตอบโดยบอท"></v-radio>
                  <v-radio
                    class="mb-2"
                    :value="false"
                    color="primary"
                    label="บอทตอบไม่ได้"
                  ></v-radio>
                </v-radio-group>
              </div>

              <v-layout wrap>
                <v-flex xs12 class="px-1">
                  <div class="caption">Subject</div>
                  <div class="form-control">
                    <input v-model="filter.subject" type="text" />
                  </div>
                </v-flex>
                <v-flex xs12 sm6 class="px-1">
                  <div class="caption">Fullname</div>
                  <div class="form-control">
                    <input v-model="filter.contact_name" type="text" />
                  </div>
                </v-flex>
                <v-flex xs12 sm6 class="px-1">
                  <div class="caption">Email</div>
                  <div class="form-control">
                    <input v-model="filter.contact_email" type="text" />
                  </div>
                </v-flex>
                <v-flex xs12 sm6 class="px-1">
                  <div class="caption">Phone number</div>
                  <div class="form-control">
                    <input v-model="filter.contact_phone" type="number" />
                  </div>
                </v-flex>
                <v-flex sm6></v-flex>

                <v-flex xs12 sm6 class="px-1">
                  <div class="caption">Group</div>
                  <multiselect
                    v-model="filter.group"
                    class="mb-3"
                    :disabled="['only_me', 'only_group', 'only_subgroup'].includes(view_ticket)"
                    :options="agentGroupOptions"
                    label="groupname"
                    select-label
                    selected-label
                    :allow-empty="false"
                    :searchable="false"
                    deselect-label
                    track-by="groupname"
                    @input="onChangeGroup"
                  ></multiselect>
                </v-flex>
                <v-flex xs12 sm6 class="px-1">
                  <div class="caption">Assign To</div>
                  <div class="form-control">
                    <input v-model="filter.assignadminid" type="text" />
                  </div>
                </v-flex>
                <template v-if="filter.group && filter.group.id != null">
                  <v-flex xs12 sm6 class="px-1">
                    <div class="caption">Sub Group</div>
                    <multiselect
                      :key="`sub_${filter.group.id}`"
                      v-model="filter.subgroup"
                      class="mb-3"
                      :disabled="['only_me', 'only_subgroup'].includes(view_ticket)"
                      :options="agentSubGroupOptions"
                      label="subgroupname"
                      select-label
                      selected-label
                      :allow-empty="false"
                      :searchable="false"
                      deselect-label
                      track-by="subgroupname"
                      @input="onChangeSubGroup"
                    ></multiselect>
                  </v-flex>
                  <v-flex xs12 class="px-1">
                    <div class="caption">Admin</div>
                    <multiselect
                      :key="`admin_${filter.group.id}`"
                      v-model="filter.admin"
                      class="mb-3"
                      :disabled="['only_me'].includes(view_ticket)"
                      :options="agentAdminOptions"
                      label="name"
                      select-label
                      selected-label
                      :allow-empty="false"
                      :searchable="false"
                      deselect-label
                      track-by="name"
                    ></multiselect>
                  </v-flex>
                </template>
              </v-layout>

              <div class="px-1">
                <div class="caption">Priority</div>
                <multiselect
                  :key="`priority`"
                  v-model="filter.priority"
                  class="mb-3"
                  :options="priorityOptions"
                  label="text"
                  select-label
                  selected-label
                  :allow-empty="false"
                  :searchable="false"
                  deselect-label
                  track-by="text"
                ></multiselect>
              </div>

              <div class="px-1">
                <div class="caption">Tags</div>
                <v-combobox
                  v-model="tags"
                  :filter="tagsfilter"
                  :hide-no-data="!search"
                  :items="items"
                  :search-input.sync="search"
                  hide-selected
                  label="Search for an option"
                  multiple
                  small-chips
                  solo
                >
                  <template #no-data>
                    <v-list-tile>
                      <span class="subheading">Create</span>
                      <v-chip :color="`primary lighten-3`" label small>{{ search }}</v-chip>
                    </v-list-tile>
                  </template>
                  <template #selection="{ item, parent, selected }">
                    <v-chip
                      v-if="item === Object(item)"
                      :color="`primary lighten-3`"
                      :selected="selected"
                      label
                      small
                    >
                      <span class="pr-2">{{ item.text }}</span>
                      <v-icon small @click="parent.selectItem(item)">close</v-icon>
                    </v-chip>
                  </template>
                  <template #item="{ index, item }">
                    <v-list-tile-content>
                      <v-text-field
                        v-if="tagediting === item"
                        v-model="tagediting.text"
                        autofocus
                        flat
                        background-color="transparent"
                        hide-details
                        solo
                        @keyup.enter="tagsedit(index, item)"
                      ></v-text-field>
                      <v-chip v-else :color="`primary lighten-3`" label small>{{
                        item.text
                      }}</v-chip>
                    </v-list-tile-content>
                    <v-spacer></v-spacer>
                    <v-list-tile-action @click.stop>
                      <v-btn icon @click.stop.prevent="tagsedit(index, item)">
                        <v-icon>{{ tagediting !== item ? 'edit' : 'check' }}</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                  </template>
                </v-combobox>
              </div>
              <v-divider class="my-2" />

              <div class="font-wight-bold mb-2">Ticket Date</div>

              <v-layout>
                <v-flex xs6>
                  <div>
                    <div class="caption">Start Date</div>
                    <v-layout>
                      <v-flex xs10>
                        <DatePickerWithoutButton v-model="selectedDate.start">
                          <div class="form-control">
                            <input type="text" :value="getDate(selectedDate.start)" readonly />
                          </div> </DatePickerWithoutButton
                      ></v-flex>
                      <v-flex xs2>
                        <v-btn icon @click="selectedDate.start = null">
                          <v-icon>close</v-icon></v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </div></v-flex
                >
                <v-flex xs6>
                  <div>
                    <div class="caption">End Date</div>
                    <v-layout>
                      <v-flex xs10>
                        <DatePickerWithoutButton v-model="selectedDate.end">
                          <div class="form-control">
                            <input type="text" :value="getDate(selectedDate.end)" readonly />
                          </div> </DatePickerWithoutButton
                      ></v-flex>
                      <v-flex xs2>
                        <v-btn icon @click="selectedDate.end = null"> <v-icon>close</v-icon></v-btn>
                      </v-flex>
                    </v-layout>
                  </div></v-flex
                >
              </v-layout>

              <v-divider class="my-2" />

              <div class="font-wight-bold mb-2">Due Date</div>

              <v-layout>
                <v-flex xs6>
                  <div>
                    <div class="caption">Start Date</div>
                    <v-layout>
                      <v-flex xs10>
                        <DatePickerWithoutButton v-model="selectedDueDate.start">
                          <div class="form-control">
                            <input type="text" :value="getDate(selectedDueDate.start)" readonly />
                          </div> </DatePickerWithoutButton
                      ></v-flex>
                      <v-flex xs2>
                        <v-btn icon @click="selectedDueDate.start = null">
                          <v-icon>close</v-icon></v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </div></v-flex
                >
                <v-flex xs6>
                  <div>
                    <div class="caption">End Date</div>
                    <v-layout>
                      <v-flex xs10>
                        <DatePickerWithoutButton v-model="selectedDueDate.end">
                          <div class="form-control">
                            <input type="text" :value="getDate(selectedDueDate.end)" readonly />
                          </div> </DatePickerWithoutButton
                      ></v-flex>
                      <v-flex xs2>
                        <v-btn icon @click="selectedDueDate.end = null">
                          <v-icon>close</v-icon></v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </div></v-flex
                >
              </v-layout>

              <div v-if="[...$store.state.rabbitPage].includes(selectedBot.pageid)" class="px-1">
                <div class="caption">Sort By Open Ticket:</div>
                <multiselect
                  :key="`sort`"
                  v-model="filter.sort"
                  class="mb-3"
                  :options="sortOptions"
                  label="text"
                  select-label
                  selected-label
                  :allow-empty="false"
                  :searchable="false"
                  deselect-label
                  track-by="text"
                ></multiselect>
              </div>
              <ReplyCommentSearchPost
                v-if="selectedBot.pageid == '101760532365601'"
                ref="selcct-post"
                @selectedPost="onSelectedPost"
              ></ReplyCommentSearchPost>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn block color="grey" outline :loading="loading" @click="clearSearch">
                {{ $t('Clear') }}
              </v-btn>
              <v-btn block color="primary" depressed :loading="loading" @click="onSearch">
                {{ $t('Search') }}
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
    <div class="mb-2">
      <v-chip v-for="(item, k) in showFilter" :key="k" dark color="blue">{{ item }}</v-chip>
    </div>

    <div class="text-xs-center pb-2 mt-2">
      <v-layout>
        <v-flex v-if="[...$store.state.bbqPage].includes(selectedBot.pageid)" xs1>
          <v-select
            v-model="limit"
            :items="pagelimit"
            solo
            small
            class="browser-default mb-2"
            hide-details
            @change="onChangeLimit"
          ></v-select>
        </v-flex>
        <v-flex xs9>
          <Pagination
            :key="page"
            v-model="page"
            :limit="limit"
            :total="total"
            @onChange="onChange($event)"
          >
          </Pagination
        ></v-flex>
        <v-flex xs2>
          <div style="float: right; font-weight: 700; font-size: large; padding-top: 14px">
            Total : {{ total ? total : 0 }}
          </div></v-flex
        >
      </v-layout>
    </div>
    <div v-if="isShowSelectAllCloseTicket" class="pb-2">
      <v-btn
        depressed
        color="primary"
        :disabled="selectedTicket && selectedTicket.length == 0"
        outline
        @click="handleCloseSelectedTicket"
        >Close Ticket</v-btn
      >
    </div>
    <template v-if="showTable">
      <v-data-table
        :key="timestamp"
        v-model="selectedTicket"
        :headers="headers"
        :pagination.sync="pagination"
        :items="ticketFormat"
        item-key="id"
        class="elevation-1"
        hide-actions
        :loading="loading"
        :select-all="isShowSelectAllCloseTicket"
      >
        <!-- Name,Email,Phone,Channel , Note, Status, Assign to, Group ,Subgroup -->
        <template #items="props">
          <tr
            class="lighten-5"
            :class="{
              grey: props.item.status == 'closed',
              orange: props.item.status == 'pending',
              red: props.item.status == 'cancelled',
              purple: props.item.status == 'cancelled by customer'
            }"
            @click="$refs['editticket_' + props.item.id].openModal()"
          >
            <td v-if="isShowSelectAllCloseTicket" @click.stop="">
              <v-checkbox
                v-model="props.selected"
                style="display: inline-block"
                class="ma-0"
                color="primary"
                hide-details
              ></v-checkbox>
            </td>
            <td class="d-flex">
              <v-layout row>
                <v-btn
                  icon
                  outline
                  color="primary"
                  @click.stop="goToLivechat(props.item, props.item.app)"
                >
                  <em class="fas fa-comments" />
                </v-btn>
                <v-btn
                  v-if="
                    $store.state.rabbitReplyFBPostPage.includes(selectedBot.pageid) &&
                    props.item.postid
                  "
                  icon
                  outline
                  color="primary"
                  @click.stop="goToReplyComment(props.item)"
                >
                  <em class="fas fa-comment-alt" />
                </v-btn>
                <!-- <v-btn
                  v-if="
                    ['114683640172785', '326180737483767'].includes(selectedBot.pageid) &&
                    props.item.postid
                  "
                  @click.stop="goToReplyComment(props.item)"
                  icon
                  outline
                  color="primary"
                >
                  <em class="fas fa-comment"/>
                </v-btn> -->
              </v-layout>
              <edit-ticket-monix
                v-if="isMonix"
                :ref="`editticket_${props.item.id}`"
                :key="props.item.id"
                v-model="props.item"
                :type="'edit'"
                :loading="loading"
                @editTicket="onEditTicket"
              ></edit-ticket-monix>
              <edit-ticket
                v-else
                :ref="`editticket_${props.item.id}`"
                :key="props.item.id"
                v-model="props.item"
                :type="'edit'"
                :loading="loading"
                @editTicket="onEditTicket"
              ></edit-ticket>
            </td>
            <td>{{ props.item.id }}</td>
            <td v-if="$store.state.kfcpage.includes(selectedBot.pageid)" class="text-xs-center">
              {{ props.item.orderid ? props.item.orderid : '-' }}
            </td>
            <td
              v-if="
                $store.state.kfcpage.includes(selectedBot.pageid) ||
                $store.state.oceanlifePage.includes(selectedBot.pageid) ||
                isNestle ||
                ['gpf'].includes(selectedBot.type)
              "
              class="text-xs-center"
            >
              {{ props.item.satisfaction_score ? props.item.satisfaction_score : '-' }}
            </td>
            <td
              v-if="$store.state.oceanlifePage.includes(selectedBot.pageid)"
              class="text-xs-center"
            >
              {{ props.item.recommendation_score ? props.item.recommendation_score : '-' }}
            </td>
            <!-- complacence -->

            <td v-if="selectedBot.pageid == '100207768987988'">
              {{ props.item.complacence || '-' }}
            </td>
            <td v-if="selectedBot.pageid == '100207768987988'">{{ props.item.province }}</td>

            <td>
              <v-chip v-if="props.item.priority == 'low'" color="yellow" small dark>{{
                props.item.priority
              }}</v-chip>
              <v-chip v-else-if="props.item.priority == 'medium'" color="orange" small dark>{{
                props.item.priority
              }}</v-chip>
              <v-chip v-else color="red" small dark>{{ props.item.priority }}</v-chip>
            </td>
            <td>{{ props.item.assignadminid }}</td>
            <td>
              <v-chip
                v-if="props.item.status == 'pending'"
                :color="'warning'"
                small
                disabled
                class="white--text"
                >{{ props.item.status }}</v-chip
              >
              <v-chip
                v-else-if="props.item.status == 'closed'"
                :color="'grey'"
                small
                disabled
                class="white--text"
                >{{ props.item.status }}</v-chip
              >
              <v-chip
                v-else-if="props.item.status == 'success'"
                :color="'grey'"
                small
                disabled
                class="white--text"
                >{{ props.item.status }}</v-chip
              >
              <v-chip
                v-else-if="props.item.status == 'cancelled'"
                :color="'error'"
                small
                disabled
                class="white--text"
                >{{ props.item.status }}</v-chip
              >
              <v-chip
                v-else-if="props.item.status == 'cancelled by customer'"
                :color="'#fd87ee'"
                small
                disabled
                class="white--text"
                >cancelled by customer</v-chip
              >
              <v-chip
                v-else-if="props.item.status == 'answered'"
                :color="'info'"
                small
                disabled
                class="white--text"
                >{{ props.item.status }}</v-chip
              >
              <v-chip
                v-else-if="props.item.status == 'open'"
                :color="'green'"
                small
                disabled
                class="white--text"
                >{{ props.item.status }}</v-chip
              >
              <v-chip v-else :color="'info'" small disabled class="white--text">{{
                props.item.status
              }}</v-chip>
            </td>
            <td v-if="$store.state.rabbitReplyFBPostPage.includes(selectedBot.pageid)">
              {{ props.item.postid ? 'Facebook Post' : 'Chatbot' }}
            </td>
            <td>{{ props.item.first_name }} {{ props.item.last_name }}</td>
            <td style="white-space: nowrap">
              <div>{{ remainingTime(props.item.duedate) }}</div>
            </td>
            <td style="min-width: 300px">{{ props.item.subject }}</td>
            <td style="min-width: 300px">{{ props.item.details }}</td>
            <td v-if="isJuzmatch" style="min-width: 300px">
              {{ props.item.is_send_survey ? 'ส่งแบบประเมิน' : 'ไม่ส่งแบบประเมิน' }}
            </td>
            <td>
              <template v-if="props.item.starttime">{{
                props.item.starttime | DateFormat('DD/MM/YYYY HH:mm')
              }}</template>
            </td>
            <!-- KFC -->
            <!-- v-if="selectedBot.pageid == '106855151601601'" -->
            <td>
              <template v-if="props.item.adminfirstresponsetime">
                {{ props.item.adminfirstresponsetime | DateFormat('DD/MM/YYYY HH:mm') }}</template
              >
            </td>
            <!-- End KFC -->
            <td>
              <template v-if="props.item.endtime">{{
                props.item.endtime | DateFormat('DD/MM/YYYY HH:mm')
              }}</template>
            </td>
            <td>
              <template v-if="props.item.starttime && props.item.endtime">{{
                transformDurationTime(diffSecond(props.item.endtime, props.item.starttime))
              }}</template>
            </td>
            <td>
              <template v-if="props.item.duedate">{{
                props.item.duedate | DateFormat('DD/MM/YYYY HH:mm')
              }}</template>
            </td>
            <template v-if="isRatchthani">
              <td>
                {{ props.item.overdue ? 'Yes' : 'No' }}
              </td>
              <td>
                <template v-if="props.item.last_customer_reply">
                  {{ props.item.last_customer_reply | DateFormat('DD/MM/YYYY HH:mm') }}
                </template>
                <template v-else>-</template>
              </td>
              <td>
                <template v-if="props.item.last_admin_reply">
                  {{ props.item.last_admin_reply | DateFormat('DD/MM/YYYY HH:mm') }}
                </template>
                <template v-else>-</template>
              </td>
              <td>
                {{ props.item.satisfaction_score || '-' }}
              </td>
              <td>
                {{ props.item.suggestion_note || '-' }}
              </td>
            </template>
            <td style="min-width: 300px">{{ props.item.tags }}</td>
            <template v-if="selectedBot.type === 'baac'">
              <td v-if="props.item.satisfaction_score">
                <v-rating
                  :value="props.item.satisfaction_score"
                  small
                  dense
                  readonly
                  class="text-no-wrap"
                ></v-rating>
              </td>
              <td v-else>-</td>
            </template>
            <td>
              {{
                groups[props.item.assigngroupid] ? groups[props.item.assigngroupid].groupname : '-'
              }}
            </td>
            <td>
              {{
                subgroups[props.item.assignsubgroupid]
                  ? subgroups[props.item.assignsubgroupid].subgroupname
                  : '-'
              }}
            </td>
            <td v-if="props.item.app == 'facebook'">
              <em style="color: rgb(59, 89, 152)" class="fab fa-facebook-square" />
            </td>
            <td v-else-if="props.item.app == 'line'">
              <em style="color: rgb(0, 195, 0)" class="fab fa-line" />
            </td>
            <td v-if="props.item.app == 'app'">
              <em style="color: rgb(59, 89, 152)" class="fas fa-mobile-alt" />
            </td>
            <td v-else-if="props.item.app == 'webchat'">
              <em style="color: rgb(0, 195, 0)" class="fas fa-globe" />
            </td>
            <td v-else><em style="color: grey" class="fas fa-envelope" /></td>
            <td>{{ props.item.contact_email }}</td>
            <td>{{ props.item.contact_phone }}</td>
          </tr>
        </template>
      </v-data-table>
    </template>
    <div class="text-xs-center pt-2">
      <Pagination
        :key="page"
        v-model="page"
        :limit="limit"
        :total="total"
        @onChange="onChange($event)"
      >
      </Pagination>
    </div>
    <div
      v-if="selectedBot && selectedBot.type === 'gpf'"
      class="mt-4"
      style="display: flex; justify-content: center"
    >
      <v-card class="pa-4" max-width="700px">
        <v-layout wrap>
          <v-flex xs12 class="py-2 mb-2">
            <v-layout wrap>
              <v-flex
                xs4
                class="text-xs-center primary--text"
                style="
                  display: flex;
                  align-items: flex-end;
                  justify-content: center;
                  font-weight: bold;
                  font-size: 16px;
                "
              >
                <div>
                  ความพึงพอใจ <br />
                  "เจ้าหน้าที่"
                </div>
              </v-flex>
              <v-flex xs8>
                <v-layout wrap>
                  <v-flex xs4 class="text-xs-center pb-1">จำนวนคนไม่ประเมิน</v-flex>
                  <v-flex xs4 class="text-xs-center pb-1">จำนวนคนประเมิน</v-flex>
                  <v-flex xs4 class="text-xs-center pb-1"
                    >เปอร์เซ็นความพึงพอใจ<br />เจ้าหน้าที่</v-flex
                  >
                  <v-flex xs4 class="text-xs-center" style="display: flex; justify-content: center">
                    <div class="grey lighten-2 py-2" style="width: 100px">
                      {{ gpfSatisfactionScores.not_admin_rated }}
                    </div></v-flex
                  >
                  <v-flex
                    xs4
                    class="text-xs-center px-3"
                    style="display: flex; justify-content: center"
                  >
                    <div class="grey lighten-2 py-2" style="width: 100px">
                      {{ gpfSatisfactionScores.admin_rated }}
                    </div></v-flex
                  >
                  <v-flex xs4 class="text-xs-center" style="display: flex; justify-content: center">
                    <div class="primary py-2 white--text" style="width: 100px">
                      {{ gpfSatisfactionScores.percent_admin_rated }}%
                    </div></v-flex
                  >
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 class="py-2">
            <v-layout wrap>
              <v-flex
                xs4
                class="text-xs-center primary--text"
                style="
                  display: flex;
                  align-items: flex-end;
                  justify-content: center;
                  font-weight: bold;
                  font-size: 16px;
                "
              >
                <div>
                  ความพึงพอใจ <br />
                  "บอท"
                </div>
              </v-flex>
              <v-flex xs8>
                <v-layout wrap>
                  <v-flex xs4 class="text-xs-center pb-1">จำนวนคนไม่ประเมิน</v-flex>
                  <v-flex xs4 class="text-xs-center pb-1">จำนวนคนประเมิน</v-flex>
                  <v-flex xs4 class="text-xs-center pb-1"
                    >เปอร์เซ็นความพึงพอใจ<br />เจ้าหน้าที่</v-flex
                  >
                  <v-flex xs4 class="text-xs-center" style="display: flex; justify-content: center">
                    <div class="grey lighten-2 py-2" style="width: 100px">
                      {{ gpfSatisfactionScores.not_bot_rated }}
                    </div></v-flex
                  >
                  <v-flex
                    xs4
                    class="text-xs-center px-3"
                    style="display: flex; justify-content: center"
                  >
                    <div class="grey lighten-2 py-2" style="width: 100px">
                      {{ gpfSatisfactionScores.bot_rated }}
                    </div></v-flex
                  >
                  <v-flex xs4 class="text-xs-center" style="display: flex; justify-content: center">
                    <div class="primary py-2 white--text" style="width: 100px">
                      {{ gpfSatisfactionScores.percent_bot_rated }}%
                    </div></v-flex
                  >
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </div>

    <ExportGroup
      v-model="showExportTicket"
      :total="total"
      :limit="100000"
      @onExport="exportTicket"
    />
  </v-container>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
const EditTicket = () => import('./EditTicket')
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'
import * as XLSX from 'xlsx'
import Pagination from '@/components/elements/Pagination.vue'
import EditTicketMonix from './EditTicketMonix.vue'
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import { notificationNewTicket } from '@/utils/notification'
import ReplyCommentSearchPost from './RabbitReplyFBPost/ReplyCommentSearchPost'
import ExportGroup from '@/components/elements/ExportGroup.vue'
import { handleResponse, handleApiError } from '@/api/util'
import ticketApi from '@/api/ticket'
import { PAGE, PAGE_GROUP } from '../../../../constants/page'

const INTERVAL_TICKET = 120000
export default {
  components: {
    EditTicket,
    Multiselect,
    Pagination,
    EditTicketMonix,
    DatePickerWithoutButton,
    ReplyCommentSearchPost,
    ExportGroup
  },
  data() {
    return {
      countStatus: {},
      page: 1,
      timestamp: moment().format('x'),
      showSearch: false,
      filter: {
        id: '',
        subject: '',
        contact_name: '',
        contact_email: '',
        channel: null,
        status: null,
        group: {
          groupname: 'All',
          id: null
        },
        contact_phone: '',
        sort: {
          text: 'All',
          value: null
        },
        assignadminid: '',
        botreply: null
      },
      pagination: {
        sortBy: 'starttime',
        descending: true,
        rowsPerPage: 100
      },
      priorityOptions: [
        {
          text: 'All',
          value: null
        },
        {
          text: 'Low',
          value: 'low'
        },
        {
          text: 'Medium',
          value: 'medium'
        },
        {
          text: 'High',
          value: 'high'
        }
      ],
      sortOptions: [
        {
          text: 'All',
          value: null
        },
        {
          text: 'Newest',
          value: 'desc'
        },
        {
          text: 'Oldest',
          value: 'asc'
        }
      ],

      headers: [
        { text: '', sortable: false },
        { text: 'ID', value: 'id' },
        { text: 'Priority', value: 'priority' },
        { text: 'Assign To', value: 'assignadminid' },
        { text: 'Status', value: 'status' },
        { text: 'Name', value: 'first_name' },
        { text: 'Remaining Time', value: 'remainingtime' },
        { text: 'Subject', value: 'subject' },
        { text: 'Details', value: 'details' },
        { text: 'Start time', value: 'starttime' },
        { text: 'Admin First Time Response', value: 'adminfirstresponsetime' },
        { text: 'End Time', value: 'endtime' },
        { text: 'Time Closed', value: 'timeclosed' },
        { text: 'Due Date', value: 'duedate' },
        { text: 'Tags', value: 'tags' },
        { text: 'Group', value: 'assigngroupid' },
        { text: 'Subgroup', value: 'assignsubgroupid' },
        { text: 'Channel', value: 'channel' },
        { text: 'Email', value: 'email' },
        { text: 'Phone', value: 'phoneno' }
      ],
      tickets: [],
      exportloading: false,
      privilegeshow: {},
      loading: true,
      offset: 0,
      limit: 20,
      total: 0,
      showAdd: false,
      groups: {},
      subgroups: {},
      tempFilter: {},
      selectedDate: {
        start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD'),
        starttime: null,
        endtime: null
      },
      selectedDueDate: {
        start: null,
        end: null,
        starttime: null,
        endtime: null
      },
      items: [
        { header: 'Select an option or create one' }
        // {
        //   text: 'Foo',
        //   color: 'blue'
        // },
        // {
        //   text: 'Bar',
        //   color: 'red'
        // }
      ],
      search: null,
      timer: null,
      tagediting: null,
      tags: [],
      showTable: true,
      filterTickets: [],
      view_ticket: '',
      gpfSatisfactionScores: {},
      pagelimit: [10, 20, 50],
      showExportTicket: false,
      selectedTicket: []
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      agentGroup: 'getAgentGroup',
      loadingAgentGroup: 'getLoadingAgentGroup',
      agentSubGroup: 'getAgentSubgroup',
      loadingAgentSubGroup: 'getLoadingAgentSubgroup',
      agents: 'getAgent',
      loadingAgent: 'getLoadingAgent',
      isMonix: 'isMonix',
      currentLang: 'currentLang'
    }),
    isJuzmatch() {
      return [
        ...PAGE.JUZMATCH_CRM,
        ...PAGE.JUZMATCH_SALE,
        ...PAGE.JUZMATCH_CRM_TEST,
        ...PAGE.JUZMATCH_SALE_TEST
      ].includes(this.selectedBot.pageid)
    },
    isNestle() {
      return (
        this.selectedBot &&
        this.$store.state.nestlePages.some((page) => page.pageid == this.selectedBot.pageid)
      )
    },
    sumCountStatus() {
      let data = 0
      for (const key in this.countStatus) {
        data += parseInt(this.countStatus[key])
      }
      return data
    },
    ticketFormat() {
      if (this.selectedBot.pageid == '100207768987988') {
        let output = []
        this.tickets.forEach((ele) => {
          if (ele.json_variable) {
            try {
              var json_variable = ele.json_variable ? JSON.parse(ele.json_variable) : {}
            } catch (error) {
              var json_variable = ele.json_variable
            }
            let temp_ticket = ele
            temp_ticket.json_variable = json_variable
            if (temp_ticket.json_variable.address) {
              let sub_address = temp_ticket.json_variable.address.split(' ')
              temp_ticket.province = sub_address[sub_address.length - 2]
              output.push(temp_ticket)
            } else {
              output.push(ele)
            }
          } else {
            output.push(ele)
          }
        })

        return output
      } else {
        return this.tickets
      }
    },
    showFilter() {
      var result = []
      if (this.filter.channel) {
        result.push(`Channel: ${this.filter.channel}`)
      }
      if (this.filter.id) {
        result.push(`ID: ${this.filter.id}`)
      }
      if (this.filter.status) {
        result.push(`Status: ${this.filter.status}`)
      }
      if (this.filter.group && this.filter.group.groupname != 'All') {
        result.push(`Group: ${this.filter.group.groupname}`)
      }
      if (this.filter.assignadminid) {
        result.push(`Assgin To: ${this.filter.assignadminid}`)
      }
      if (this.filter.subgroup && this.filter.subgroup.subgroupname != 'All') {
        result.push(`Sub Group: ${this.filter.subgroup.subgroupname}`)
      }
      if (this.filter.admin && this.filter.admin.name != 'All') {
        result.push(`Name: ${this.filter.admin.name}`)
      }
      if (this.filter.priority && this.filter.priority.text != 'All') {
        result.push(`Priority: ${this.filter.priority.text}`)
      }
      if (this.tags.length) {
        result.push(`Tags: ${this.tags.map((el) => el.text)}`)
      }
      if (this.selectedDate.start) {
        result.push(`Start Date: ${moment(this.selectedDate.start).format('DD/MM/YYYY')}`)
      }
      if (this.selectedDate.end) {
        result.push(`End Date: ${moment(this.selectedDate.end).format('DD/MM/YYYY')}`)
      }
      if (this.selectedDueDate.start) {
        result.push(`Start Due Date: ${moment(this.selectedDueDate.start).format('DD/MM/YYYY')}`)
      }
      if (this.selectedDueDate.end) {
        result.push(`End Due Date: ${moment(this.selectedDueDate.end).format('DD/MM/YYYY')}`)
      }
      if (this.filter.status) {
        result.push(`Subject: ${this.filter.status}`)
      }
      if (this.filter.contact_name) {
        result.push(`Fullname: ${this.filter.contact_name}`)
      }
      if (this.filter.contact_email) {
        result.push(`Email: ${this.filter.contact_email}`)
      }
      return result
    },
    pages() {
      if (this.pagination.rowsPerPage == null || this.total == null) return 0

      return Math.ceil(this.total / this.pagination.rowsPerPage)
    },
    agentGroupOptions() {
      return this.loadingAgentGroup
        ? []
        : [
            {
              groupname: 'All',
              id: null
            },
            ...this.agentGroup
          ]
    },
    agentSubGroupOptions() {
      if (!this.filter.group) {
        return []
      }
      var subgroup = this.agentSubGroup.filter((el) => {
        return el.admingroupid == this.filter.group.id
      })
      return this.loadingAgentSubGroup
        ? []
        : [
            {
              subgroupname: 'All',
              id: null
            },
            ...subgroup
          ]
    },
    agentAdminOptions() {
      if (!this.filter.group || !this.filter.subgroup) {
        return []
      }
      var agents = this.agents.filter((el) => {
        return el.subgroupname == this.filter.subgroup.subgroupname
      })
      return this.loadingAgent
        ? []
        : [
            {
              name: 'All',
              adminid: null
            },
            ...agents
          ]
    },
    moment() {
      return moment
    },
    isShowSelectAllCloseTicket() {
      return (
        this.selectedBot &&
        (['mtc', 'autocash'].includes(this.selectedBot.type) ||
          [...PAGE.JUZMATCH_SALE, ...PAGE.JUZMATCH_CRM].includes(this.selectedBot.pageid))
      )
    },
    selectedTicketId() {
      const selectedTicket = this.selectedTicket
      if (selectedTicket && selectedTicket.length > 0) {
        return selectedTicket.map((el) => {
          return { id: el.id }
        })
      } else {
        return []
      }
    },
    isRatchthani() {
      return PAGE.RATCHTHANI.includes(this.selectedBot.pageid)
    },
    isNT() {
      return [PAGE_GROUP.NT].includes(this.selectedBot.page_group)
    }
  },
  watch: {
    pagination: {
      handler() {
        // this.getTickets()
      },
      deep: true
    },
    tags(val, prev) {
      if (val.length === prev.length) return

      this.tags = val.map((v) => {
        if (typeof v === 'string') {
          v = {
            text: v
          }

          this.items.push(v)
        }

        return v
      })
    }
  },
  created() {
    momentDurationFormatSetup(moment)
  },

  async mounted() {
    const vm = this
    vm.$root.$on('reloadTickets', () => {
      // your code goes here
      vm.onSearch()
    })

    vm.loading = true
    await vm.initTableHeader()

    // cotto
    if (vm.selectedBot.pageid == '100207768987988') {
      let data = {
        pageid: vm.selectedBot.pageid,
        ticketdatefrom: vm.selectedDate.start,
        ticketdateto: vm.selectedDate.end,
        duedatefrom: vm.selectedDueDate.end,
        duedateto: vm.selectedDueDate.end
      }

      const countStatus = await api.ticketCountStatusWithCondition(data)
      if (countStatus && countStatus[0]) {
        vm.countStatus = countStatus[0]
      }
    }

    try {
      var responseGroup = await vm.getAdminGroup()
      var responseSubGroup = await vm.getAdminSubGroup()
      if (responseGroup.data) {
        var group = {}
        responseGroup.data.map((el) => {
          group[el.id] = el
        })
        vm.groups = group
      }
      if (responseSubGroup.data) {
        var subgroup = {}
        responseSubGroup.data.map((el) => {
          subgroup[el.id] = el
        })
        this.subgroups = subgroup
      }

      var filter = vm.initFilter()
      var response = await vm.getTickets(filter)
      if (response.data) {
        vm.tickets = response.data
        vm.total = response.total
      }
      if (!['114683640172785', '326180737483767'].includes(vm.selectedBot.pageid)) {
        vm.timer = setInterval(async () => {
          var filter = vm.initFilter()
          var response = await vm.getTickets(filter)
          if (response.data) {
            vm.tickets = response.data
            vm.total = response.total
            if (vm.selectedBot && vm.selectedBot.type === 'gpf') {
              notificationNewTicket({
                tickets: response.data,
                timeInterval: INTERVAL_TICKET
              })
            }
          }
        }, INTERVAL_TICKET)
      }
    } catch (error) {
      console.error(error)
    }
    vm.loading = false
  },
  beforeDestroy: function () {
    clearInterval(this.timer)
  },
  methods: {
    async initTableHeader() {
      const vm = this
      try {
        if (vm.selectedBot.pageid == '100207768987988') {
          let item = [
            { text: 'ความพึงพอใจ', value: 'complacence' },
            { text: 'จังหวัด', value: 'province' }
          ]
          vm.headers.splice(2, 0, ...item)
        }

        if (vm.isJuzmatch) {
          let item = [{ text: 'Survey', value: 'is_send_survey' }]
          vm.headers.splice(9, 0, ...item)
        }

        //KFC
        if (vm.$store.state.kfcpage.includes(vm.selectedBot.pageid)) {
          let item = [
            { text: 'Order ID', value: 'orderid' },
            { text: 'ความพึงพอใจ', value: 'satisfaction_score' }
          ]
          vm.headers.splice(2, 0, ...item)
        }

        if (['gpf'].includes(vm.selectedBot.type) || vm.isNestle) {
          await vm.handleGpfGetSatisfactionScores()
          const text = vm.selectedBot.type === 'gpf' ? 'ความพึงพอใจ' : vm.$t('satisfaction_score')
          let item = [{ text: text, value: 'satisfaction_score' }]
          vm.headers.splice(2, 0, ...item)
        }

        //Ocean
        if (vm.$store.state.oceanlifePage.includes(vm.selectedBot.pageid)) {
          let item = [
            { text: 'คะแนนความพึงพอใจ', value: 'satisfaction_score' },
            { text: 'คะแนนในการแนะนำบริการ', value: 'recommendation_score' }
          ]
          vm.headers.splice(2, 0, ...item)
        }

        if (vm.$store.state.rabbitReplyFBPostPage.includes(vm.selectedBot.pageid)) {
          let item = [{ text: 'From', value: 'from' }]
          vm.headers.splice(5, 0, ...item)
        }

        if (vm.isRatchthani) {
          let item = [
            { text: 'Overdue', value: 'overdue' },
            { text: 'Last Customer Response', value: 'last_customer_reply' },
            { text: 'Last Admin Response', value: 'last_admin_reply' },
            { text: 'คะแนนประเมิน', value: 'satisfaction_score' },
            { text: 'ข้อเสนอแนะเพิ่มเติม', value: 'suggestion_note' }
          ]
          vm.headers.splice(14, 0, ...item)
        }

        if (vm.selectedBot.type === 'baac') {
          vm.headers.splice(15, 0, { text: 'Satisfaction Score', value: 'satisfaction_score' })
        }
      } catch (error) {
        console.error(error)
      }
    },
    async exportTicket(callback) {
      await this.$store.dispatch('loading')
      await this.exportData(callback)
      await this.$store.dispatch('loading')
    },
    numberWithCommas(x) {
      x = x.toString()
      var pattern = /(-?\d+)(\d{3})/
      while (pattern.test(x)) x = x.replace(pattern, '$1,$2')
      return x
    },
    onSelectedPost(val) {
      if (val) {
        this.filter.postid = val
      }
    },
    initFilter() {
      var filter = {}
      if (this.selectedDate.start) {
        filter.starttime = moment(this.selectedDate.start).format('YYYY-MM-DD')
      }

      if (this.selectedDate.end) {
        filter.endtime = moment(this.selectedDate.end).format('YYYY-MM-DD')
      }
      if (this.$store.state.privilege) {
        this.view_ticket = this.$store.state.privilege.view_ticket
        if (this.view_ticket == 'all') {
          // dont do shit
        } else if (this.view_ticket == 'only_me') {
          Object.assign(filter, {
            assignadminid: this.$store.state.userid
          })
          if (this.$store.state.admingroupid || this.$store.state.admingroupid === 0) {
            this.filter.group = this.groups[this.$store.state.admingroupid]
          }
          if (this.$store.state.adminsubgroupid || this.$store.state.adminsubgroupid === 0) {
            this.filter.subgroup = this.subgroups[this.$store.state.adminsubgroupid]
          }
          if (this.agents) {
            this.filter.admin = this.agents.find((el) => el.adminid == this.$store.state.userid)
          }
        } else if (this.view_ticket == 'only_group') {
          Object.assign(filter, {
            assigngroupid: this.$store.state.admingroupid
          })
          if (this.$store.state.admingroupid || this.$store.state.admingroupid === 0) {
            this.filter.group = this.groups[this.$store.state.admingroupid]
          }
        } else if (this.view_ticket == 'only_subgroup') {
          Object.assign(filter, {
            assignsubgroupid: this.$store.state.adminsubgroupid
          })
          if (this.$store.state.admingroupid || this.$store.state.admingroupid === 0) {
            this.filter.group = this.groups[this.$store.state.admingroupid]
          }
          if (this.$store.state.adminsubgroupid || this.$store.state.adminsubgroupid === 0) {
            this.filter.subgroup = this.subgroups[this.$store.state.adminsubgroupid]
          }
        }
      }
      this.tempFilter = { ...this.filter }
      return filter
    },
    getDate(date) {
      if (date) {
        return moment(date).format('DD/MM/YYYY')
      } else {
        return ''
      }
    },
    async onChange(val) {
      if (val.limit !== this.limit || val.offset !== this.offset) {
        this.loading = true
        try {
          var filter = this.formatFilter()
          this.limit = val.limit
          this.offset = val.offset
          var response = await this.getTickets(filter)
          if (response.data) {
            this.$nextTick(() => {
              this.tickets = response.data
            })
            this.total = response.total
          }
        } catch (error) {
          console.log(error)
        }
        this.loading = false
        this.showSearch = false
      }
    },
    clearSearch() {
      if (this.selectedBot.pageid == '101760532365601') {
        this.$refs['selcct-post'].clearPost()
      }
      this.filter = { ...this.tempFilter }
      this.selectedDate = {
        start: null,
        end: null,
        starttime: null,
        endtime: null
      }
      this.selectedDueDate = {
        start: null,
        end: null,
        starttime: null,
        endtime: null
      }
      this.onSearch()
    },
    async exportData(options) {
      let vm = this
      let filename = 'ticketlist'

      var json = []

      var filter = this.formatFilter()
      vm.exportloading = true
      const { submitData, submitAoaData, ...filterOptions } = options
      var response = await this.getExportTickets(filter, false, filterOptions)
      if (response.data) {
        var tickets = response.data
      }

      json = tickets.map((el) => {
        var objData
        objData = {
          ID: el.id ? el.id : '-',
          Priority: el.priority ? el.priority : '-'
        }

        if (this.$store.state.kfcpage.includes(this.selectedBot.pageid)) {
          // KFC
          var extraExport = {
            'Order ID': el.orderid ? el.orderid : '-',
            คะแนนความพึงพอใจ: el.satisfaction_score ? el.satisfaction_score : '-',
            ข้อเสนอแนะ: el.suggestion_note ? el.suggestion_note : '-'
          }
          Object.assign(objData, extraExport)
        }

        if (['gpf'].includes(this.selectedBot.type) || this.isNestle) {
          const userid = el.userid
          let userid_split = null
          try {
            userid_split = el.app == 'line' ? userid.split('__')[0] : userid
          } catch (error) {
            userid_split = userid
          }
          var extraExport = {
            pageuid: userid_split,
            คะแนนความพึงพอใจ: el.satisfaction_score ? el.satisfaction_score : '-'
          }
          Object.assign(objData, extraExport)
        }

        if ([...this.$store.state.oceanlifePage].includes(this.selectedBot.pageid)) {
          let extraExport = {
            คะแนนความพึงพอใจ: el.satisfaction_score ? el.satisfaction_score : '-',
            คะแนนในการแนะนำบริการ: el.recommendation_score ? el.recommendation_score : '-'
          }
          Object.assign(objData, extraExport)
        }

        let adminTakeTime =
          el.starttime && el.adminfirstresponsetime
            ? this.transformDurationTime(this.diffSecond(el.adminfirstresponsetime, el.starttime))
            : '-'

        Object.assign(objData, {
          Name: el.first_name ? `${el.first_name}${el.last_name ? ` ${el.last_name}` : ''}` : '-',
          'Latest Email': el.email ? el.email : '-',
          Channel: el.app || '-',
          ...(this.isNestle ? { Social: this.selectedBot.pagename } : {}),
          Subject: el.subject ? el.subject : '-',
          Details: el.details
            ? el.details.length > 32767
              ? el.details.substring(0, 32766) + '…'
              : el.details
            : '-',
          Status: el.status ? el.status : '-',
          'Assign To': el.assignadminid ? el.assignadminid : '-',
          Group: this.groups[el.assigngroupid] ? this.groups[el.assigngroupid].groupname : '-',
          Subgroup: this.subgroups[el.assignsubgroupid]
            ? this.subgroups[el.assignsubgroupid].subgroupname
            : '-',
          'Start time (Date)': el.starttime ? moment(el.starttime).format('DD/MM/YYYY') : '-',
          'Start time (Time)': el.starttime ? moment(el.starttime).format('HH:mm') : '-',
          'Admin First Response (Date)': el.adminfirstresponsetime
            ? moment(el.adminfirstresponsetime).format('DD/MM/YYYY')
            : '-',
          'Admin First Response (Time)': el.adminfirstresponsetime
            ? moment(el.adminfirstresponsetime).format('HH:mm')
            : '-',
          'Admin take time': adminTakeTime,
          'End Time': el.endtime ? moment(el.endtime).format('DD/MM/YYYY HH:mm') : '-',
          'Time Closed':
            el.starttime && el.endtime
              ? this.transformDurationTime(this.diffSecond(el.endtime, el.starttime))
              : '-',
          'Due Date': el.duedate ? moment(el.duedate).format('DD/MM/YYYY HH:mm') : '-',
          ...(this.isRatchthani
            ? {
                Overdue: el.overdue ? (el.overdue === 'true' ? 'Yes' : 'No') : '-',
                'Last Customer Response': el.last_customer_reply
                  ? moment(el.last_customer_reply).format('DD/MM/YYYY HH:mm')
                  : '-',
                'Last Admin Response': el.last_admin_reply
                  ? moment(el.last_admin_reply).format('DD/MM/YYYY HH:mm')
                  : '-',
                คะแนนประเมิน: el.satisfaction_score || '-',
                ข้อเสนอแนะเพิ่มเติม: el.suggestion_note || '-'
              }
            : {}),
          Tags: el.tags ? el.tags : '-',
          ...(this.selectedBot.type === 'baac'
            ? { 'Satisfaction score': (el.satisfaction_score || '-').toString() }
            : {}),
          ...(this.isNestle ? { 'User tag': el.usertags } : {}),
          ...(['nt'].includes(this.selectedBot.type)
            ? {
                'Reason Lv.1': el.reasoning ? el.reasoning.level_1 : '-',
                'Reason Lv.2': el.reasoning ? el.reasoning.level_2 : '-',
                'Reason Lv.3': el.reasoning ? el.reasoning.level_3 : '-'
              }
            : {})
        })

        return objData
      })

      var dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, filename + '.xlsx')
      vm.exportloading = false
    },

    goToLivechat: function (user, app) {
      let routeData = this.$router.resolve({
        name: 'livechat',
        path: '/' + this.currentLang + '/livechat',
        query: {
          userid: user.userid,
          user: user.context == 'contactadmin' ? 'admin' : 'bot',
          app: app
        }
      })
      window.open(routeData.href, '_blank')
    },
    goToReplyComment: function (user) {
      let routeData = this.$router.resolve({
        // name: 'replycomment',
        path: '/' + this.currentLang + '/rabbitreplyfbpost',
        query: {
          userid: user.userid,
          user: user.context == 'contactadmin' ? 'admin' : 'bot',
          postid: user.postid
        }
      })
      window.open(routeData.href, '_blank')
    },
    durationTime(start, end) {
      var startTime = start
      var endTime = end
      var minutes = moment
        .duration(moment(endTime, 'YYYY/MM/DD HH:mm').diff(moment(startTime, 'YYYY/MM/DD HH:mm')))
        .asMinutes()
        .toFixed(2)
      return minutes
    },
    addDurationUnit(minutes) {
      return moment.duration(parseFloat(minutes), 'minutes').format('h [hrs], m [min]')
    },
    remainingTime(end) {
      const startTime = moment()
      const endTime = moment(end)
      if (startTime.isBefore(endTime)) {
        const minutes = moment.duration(endTime.diff(startTime)).asMinutes().toFixed(2)
        return moment.duration(parseFloat(minutes), 'minutes').format('h [hrs], m [min]')
      } else {
        return 0
      }
    },
    async onSearch() {
      this.loading = true
      try {
        var filter = this.formatFilter()
        this.offset = 0
        var response = await this.getTickets(filter)

        if (this.selectedBot.pageid == '100207768987988') {
          //cotto
          this.getCountTicket()
        }

        if (['gpf'].includes(this.selectedBot.type)) {
          this.handleGpfGetSatisfactionScores()
        }

        if (response.data) {
          this.$nextTick(() => {
            this.tickets = response.data
          })
          this.total = response.total
        }
      } catch (error) {
        console.log(error)
      }
      this.loading = false
      this.showSearch = false
    },
    formatFilter() {
      var data = {}

      if (this.filter.channel) {
        data.channel = this.filter.channel
      }
      if (this.filter.id) {
        data.id = this.filter.id
      }
      if (this.filter.status) {
        data.status = this.filter.status
      }
      if (this.filter.contact_phone) {
        data.contact_phone = this.filter.contact_phone
      }

      if (this.filter.group && this.filter.group.id != null) {
        data.assigngroupid = this.filter.group.id
      }

      if (this.filter.assignadminid) {
        data.assignadminid = this.filter.assignadminid
      }

      if (this.filter.subgroup && this.filter.subgroup.id != null) {
        data.assignsubgroupid = this.filter.subgroup.id
      }
      if (this.filter.admin && this.filter.admin.adminid != null) {
        data.assignadminid = this.filter.admin.adminid
      }

      if (this.selectedDate.start) {
        data.starttime = moment(this.selectedDate.start).format('YYYY-MM-DD')
      }

      if (this.selectedDate.end) {
        data.endtime = moment(this.selectedDate.end).format('YYYY-MM-DD')
      }

      if (this.selectedDueDate.start) {
        data.startDueDate = moment(this.selectedDueDate.start).format('YYYY-MM-DD')
      }

      if (this.selectedDueDate.end) {
        data.endDueDate = moment(this.selectedDueDate.end).format('YYYY-MM-DD')
      }

      if (this.filter.priority && this.filter.priority.value != null) {
        data.priority = this.filter.priority.value
      }
      if (this.filter.sort && this.filter.sort.value != null) {
        data.orderby = this.filter.sort.value
      }
      if (this.filter.subject) {
        data.subject = this.filter.subject
      }
      if (this.filter.contact_name) {
        data.contact_name = this.filter.contact_name
      }
      if (this.filter.contact_email) {
        data.contact_email = this.filter.contact_email
      }

      if (this.filter.postid) {
        data.postid = this.filter.postid
      }

      if (this.filter.botreply == true || this.filter.botreply == false) {
        data.botreply = this.filter.botreply
      }

      if (this.tags && this.tags.length > 0) {
        var tags = this.tags.map((el) => {
          return el.text
        })
        data.tags = tags.join(',')
      }
      return data
    },
    tagsedit(index, item) {
      if (!this.tagediting) {
        this.tagediting = item
        this.index = index
      } else {
        this.tagediting = null
        this.index = -1
      }
    },
    tagsfilter(item, queryText, itemText) {
      if (item.header) return false

      const hasValue = (val) => (val != null ? val : '')

      const text = hasValue(itemText)
      const query = hasValue(queryText)

      return text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
    },

    onChangeGroup(val) {
      if (val.id) {
        this.$set(this.filter, 'subgroup', { id: null, subgroupname: 'All' })
      } else {
        this.$set(this.filter, 'subgroup', null)
      }
      this.$set(this.filter, 'admin', null)
    },
    onChangeSubGroup(val) {
      this.$set(this.filter, 'admin', null)
    },
    async onAddTicket(ticket) {
      window.location.reload()

      // var response = await this.getTicketById(ticket.id)
      // if (response.data && response.data.length > 0) {
      //   this.tickets.unshift(response.data[0])
      // }
      // this.filterTickets = []
      // this.showTable = false
      // await this.$nextTick()
      // this.filterTickets = this.onfilterTickets()
      // console.log(this.filterTickets)
      // this.timestamp = moment().format('x')
      // this.showTable = true
    },
    onEditTicket(ticket) {
      // window.location.reload()
      var vm = this
      var index = this.tickets.findIndex((el) => el.id == ticket.id)

      this.$set(vm.tickets, index, { ...vm.tickets[index], ...ticket })
      // var response = await this.getTicketById(ticket.id)
      // var index = this.tickets.findIndex(el => {
      //   return el.id == ticket.id
      // })
      // if (index != -1 && response.data && response.data.length > 0) {
      //   this.$set(this.tickets, index, response.data[0])
      // }
      // this.filterTickets = []
      // this.showTable = false
      // await this.$nextTick()
      // this.filterTickets = this.onfilterTickets()
      // this.timestamp = moment().format('x')
      // this.showTable = true
    },
    getTicketById(id) {
      var data = {
        id: id,
        pageid: this.selectedBot.pageid
      }
      return new Promise((resolve, reject) => {
        api.getTicketById(data, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }
          resolve(response)
        })
      })
    },
    getTickets(filter = [], allpage = false, options = null) {
      let data = {
        pageid: this.selectedBot.pageid,
        ...filter
      }
      if (!allpage) {
        Object.assign(data, { offset: this.offset })
        Object.assign(data, { limit: this.limit })
      }
      if (options) {
        data = { ...data, ...options }
      }

      return new Promise((resolve, reject) => {
        api.getTickets(data, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }
          resolve(response)
        })
      })
    },
    async getExportTickets(filter = [], allpage = false, options = null) {
      let data = {
        pageid: this.selectedBot.pageid,
        ...filter
      }
      if (!allpage) {
        Object.assign(data, { offset: this.offset })
        Object.assign(data, { limit: this.limit })
      }
      if (options) {
        data = { ...data, ...options }
      }

      const fields = [
        'id',
        'priority',
        'orderid',
        'satisfaction_score',
        'suggestion_note',
        'app',
        'recommendation_score',
        'adminfirstresponsetime',
        'starttime',
        'first_name',
        'last_name',
        'email',
        'subject',
        'details',
        'status',
        'assignadminid',
        'assigngroupid',
        'assignsubgroupid',
        'endtime',
        'duedate',
        'tags',
        'usertags'
      ]

      if (['nt'].includes(this.selectedBot.type)) {
        fields.push('reasoning')
      }

      data.fields = fields.join(',')

      try {
        const response = await ticketApi.getExportTicket({
          config: {
            params: data
          }
        })
        await handleResponse(response)
        return response.data || []
      } catch (error) {
        handleApiError(error)
      }
    },
    getAdminGroup() {
      const isNestlePage = this.isNestle
      const pageid = isNestlePage
        ? this.$store.state.nestlePages[0].pageid
        : this.selectedBot.pageid

      return new Promise((resolve, reject) => {
        api.getAdminGroup({ pageid }, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }
          resolve(response)
        })
      })
    },
    getAdminSubGroup() {
      const isNestlePage = this.isNestle
      const pageid = isNestlePage
        ? this.$store.state.nestlePages[0].pageid
        : this.selectedBot.pageid

      return new Promise((resolve, reject) => {
        api.getAdminSubGroup({ pageid }, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }
          resolve(response)
        })
      })
    },
    async getCountTicket() {
      let data = {
        pageid: this.selectedBot.pageid,
        ticketdatefrom: this.selectedDate.start,
        ticketdateto: this.selectedDate.end,
        duedatefrom: this.selectedDueDate.end,
        duedateto: this.selectedDueDate.end
      }
      const countStatus = await api.ticketCountStatusWithCondition(data)
      if (countStatus && countStatus[0]) {
        this.countStatus = countStatus[0]
      }
    },
    async handleGpfGetSatisfactionScores() {
      const vm = this
      const filter = this.initFilter()
      try {
        const response = await api.gpfGetSatisfactionScores({
          pageid: vm.selectedBot.pageid,
          ...filter
        })

        if (response && response.data) {
          vm.gpfSatisfactionScores = response.data
        }
      } catch (error) {
        console.error(error)
        return
      }
    },
    onChangeLimit() {
      this.onSearch()
    },
    async handleCloseSelectedTicket() {
      const vm = this
      try {
        const result = await vm.$swal.fire({
          type: 'warning',
          text: 'คุณต้องการ ปิดทิกเก็ต ใช่หรือไม่',
          showCancelButton: true,
          cancelButtonText: 'ยกเลิก',
          confirmButtonText: 'ตกลง',
          reverseButtons: true
        })

        if (result.value) {
          vm.updateStatusCloseMultiTicket()
        }
      } catch (error) {
        console.error(error)
      }
    },
    async updateStatusCloseMultiTicket() {
      const vm = this
      try {
        const pageId = vm.selectedBot.pageid
        const data = {
          tickets: vm.selectedTicketId
        }

        const response = await api.ticketCloseMultiTicket(data, pageId)
        if (response && response.message === 'Closed success') {
          vm.selectedTicket = []
          vm.onSearch()
        }
      } catch (error) {
        console.error(error)
      }
    },
    transformDurationTime(value) {
      const hours = Math.floor(value / 60 / 60)
      const minutes = Math.floor(value / 60) % 60
      const seconds = Math.floor(value % 60)
      const padZero = (number) => (number > 99 ? number : number.toString().padStart(2, '0'))
      return `${padZero(hours)}:${padZero(minutes)}:${padZero(seconds)}`
    },
    diffSecond(endDate, startDate) {
      const diff = moment(endDate).diff(startDate)
      return diff / 1000
    }
  }
}
</script>

<style lang="scss" scoped>
.box-status {
  border-radius: 1rem;
  color: #fff;
}

.font-total-case {
  font-weight: bold !important;
  font-size: 36px;
}

.font-bold {
  font-weight: bold !important;
  font-size: 30px;
}

.font-bold {
  font-weight: bold !important;
  font-size: 26px;
}

.bg-total {
  background: rgb(0, 56, 204);
  background: linear-gradient(
    180deg,
    rgba(0, 56, 204, 1) 0%,
    rgba(0, 56, 204, 1) 49%,
    rgba(107, 108, 255, 1) 100%
  );
}

.bg-pending {
  background: rgb(255, 148, 52);
  background: linear-gradient(
    180deg,
    rgba(255, 148, 52, 1) 0%,
    rgba(255, 158, 101, 1) 57%,
    rgba(255, 172, 146, 1) 100%
  );
}

.bg-answered {
  background: rgb(52, 157, 140);
  background: linear-gradient(
    180deg,
    rgba(52, 157, 140, 1) 0%,
    rgba(59, 204, 129, 1) 49%,
    rgba(127, 195, 153, 1) 100%
  );
}

.bg-closed {
  background: rgb(104, 224, 230);
  background: linear-gradient(
    0deg,
    rgba(104, 224, 230, 1) 0%,
    rgba(68, 197, 237, 1) 49%,
    rgba(90, 165, 232, 1) 100%
  );
}

.bg-cancled {
  background: rgb(251, 135, 222);
  background: linear-gradient(
    180deg,
    rgba(251, 135, 222, 1) 0%,
    rgba(232, 179, 255, 1) 49%,
    rgba(238, 183, 255, 1) 100%
  );
}

.bg-cancledbycustomer {
  background: rgb(255, 84, 114);
  background: linear-gradient(
    180deg,
    rgba(255, 84, 114, 1) 0%,
    rgba(213, 82, 146, 1) 49%,
    rgba(157, 89, 159, 1) 100%
  );
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/ticket/Dashboard.vue